import { SelectListItem } from './select-list-item';

export class TreatmentModel{
    public Selected:boolean;
    public Deleted: boolean;
    public ID:number;
    public PriceListName:string;
    public TherapistName:string;
    public TreatmentCode:string;
    public TreatmentCodeName:string;
    public TreatmentCodeDescription:string;
    public Price?:number;
    public Duration:number;
    public PriceList:SelectListItem;
    public Therapist:SelectListItem;
    public Items_Free_To_Attach:number;
    public Items_Count:number;
    public TreatmentStatusID:number;
    public TreatmentItemPrice:number;
    public IsSeries:boolean;
    public IsOtherTherapist:boolean;
    public IsDone:boolean;
    public TreatmentCodeID:number;
    public PriceListRefID:number;
    public AttachToOtherEvent:boolean;
    public PrevTreatmentCode: string;
    public Description: string;
    public Description_HTML: string;
    
    constructor(obj?:any){
        this.Selected = obj ? obj.ID : null; 
        this.Deleted = obj ? obj.Deleted : false; 
        this.ID = obj ? obj.ID : 0;
        this.PriceListName = obj ? obj.PriceListName : null;
        this.TherapistName = obj ? obj.TherapistName : null;
        this.TreatmentCode = obj ? obj.TreatmentCode : null;
        this.TreatmentCodeName = obj ? obj.TreatmentCodeName : null;
        this.TreatmentCodeDescription = obj ? obj.TreatmentCodeDescription : null;        this.Price = obj ? obj.Price : null;
        this.Duration = obj ? obj.Duration : null;
        this.PriceList = obj ? obj.PriceList : null;
        this.Therapist = obj ? obj.Therapist : null;
        this.Items_Free_To_Attach = obj ? obj.Items_Free_To_Attach : 0;
        this.Items_Count = obj ? obj.Items_Count : 0;
        this.TreatmentStatusID = obj ? obj.TreatmentStatusID : 0;
        this.TreatmentItemPrice = obj ? obj.TreatmentItemPrice : 0;
        this.IsSeries = obj ? obj.IsSeries : false;
        this.IsOtherTherapist = obj ? obj.IsOtherTherapist : false;
        this.IsDone = obj ? obj.IsDone : false;
        this.TreatmentCodeID = obj ? obj.TreatmentCodeID : 0;
        this.PriceListRefID = obj ? obj.PriceListRefID : 0;
        this.AttachToOtherEvent = obj ? obj.AttachToOtherEvent : 0;      
        this.PrevTreatmentCode = obj ? obj.PrevTreatmentCode   : null;
        this.Description = obj ? obj.Description : null;
        this.Description_HTML = obj ? obj.Description_HTML : null;
    }

}